import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Grid } from "@mzc-pdc/ui";
import Typography from "@components_v2/typography/typography";
import TagsInput from "../../../../features/tags-input/tags-input";
import { updateData } from "@modules/createAsset";

const TagsField = ({ pendingCreate }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const tags = useSelector(({ createAsset }) => createAsset.data?.tags);

    const onChangeTags = (newTags) => {
        dispatch(
            updateData({
                tags: newTags,
            }),
        );
    };

    return (
        <Grid container alignItems={"center"}>
            <Grid item sx={{ alignSelf: "flex-start", minWidth: "244px" }} alignItems={"center"}>
                <Typography variant={"body1"} component={"p"}>
                    {t(`common::label::Tags`, `Tags`)}
                </Typography>
            </Grid>
            <Grid
                item
                sx={{
                    flex: 1,
                    alignSelf: "flex-start",
                    maxWidth: "1000px",
                }}
            >
                <TagsInput
                    tags={tags?.map((tag) => ({ value: tag }))}
                    isEdit={false}
                    disabled={pendingCreate}
                    onDeleteTag={(index) => {
                        onChangeTags(tags.filter((_, idx) => idx !== index));
                    }}
                    onAddTag={(tag) => {
                        const newTag = tag.value;
                        onChangeTags([...(tags || []), newTag]);
                    }}
                />
            </Grid>
        </Grid>
    );
};

export default TagsField;
